import RobotoBold from './assets/fonts/Roboto-Bold.ttf';
import RobotoBoldItalic from './assets/fonts/Roboto-BoldItalic.ttf';
import RobotoItalic from './assets/fonts/Roboto-Italic.ttf';
import RobotoLight from './assets/fonts/Roboto-Light.ttf';
import RobotoLightItalic from './assets/fonts/Roboto-LightItalic.ttf';
import RobotoMedium from './assets/fonts/Roboto-Medium.ttf';
import RobotoMediumItalic from './assets/fonts/Roboto-MediumItalic.ttf';
import Roboto from './assets/fonts/Roboto-Regular.ttf';
import RobotoSemiBold from './assets/fonts/Roboto-SemiBold.ttf';

const AppFonts = `@font-face {
  font-family: 'Roboto-Regular';
  src: url(${Roboto});
}
@font-face {
  font-family: 'Roboto-SemiBold';
  src: url(${RobotoSemiBold});
}
@font-face {
  font-family: 'Roboto-Italic';
  src: url(${RobotoItalic});
}
@font-face {
  font-family: 'Roboto-Light';
  src: url('${RobotoLight}');
}
@font-face {
  font-family: 'Roboto-LightItalic';
  src: url('${RobotoLightItalic}');
}
@font-face {
  font-family: 'Roboto-Bold';
  src: url('${RobotoBold}');
}
@font-face {
  font-family: 'Roboto-BoldItalic';
  src: url('${RobotoBoldItalic}');
}
@font-face {
  font-family: 'Roboto-Medium';
  src: url('${RobotoMedium}');
}
@font-face {
  font-family: 'Roboto-MediumItalic';
  src: url('${RobotoMediumItalic}');
}
`;

const appendFontStyle = (fontStyle) => {
  const baseStyle = document.createElement('style');

  if (baseStyle.styleSheet) {
    baseStyle.styleSheet.cssText = fontStyle;
  } else {
    baseStyle.appendChild(document.createTextNode(fontStyle));
  }

  document.head.appendChild(baseStyle);
};

appendFontStyle(AppFonts);
